import { ConditionOperator } from './editorModel';

/**
 * Trifft die Bedingung mit dem Wert aus dem Vorschauvorgang zu? (#1245)
 *
 * Nur eine Vorschau für die Bearbeiterin, keine zweite Laufzeit: gerechnet wird mit demselben
 * Wert, den die Feldauswahl anzeigt, und nach den Operatoren des nativen Modells. Wo sich das nicht sicher sagen lässt — kein Wert, kein Vergleichswert, eine Zahl, die
 * keine ist — kommt `null` zurück, und die Oberfläche sagt nichts, statt etwas zu behaupten.
 */
export const compareForPreview = (
  sample: string | null | undefined,
  operator: ConditionOperator,
  right: string | null | undefined
): boolean | null => {
  const wert = (sample ?? '').trim();

  if (operator === 'isEmpty') {
    return wert === '';
  }
  if (operator === 'isNotEmpty') {
    return wert !== '';
  }

  const vergleich = (right ?? '').trim();
  if (vergleich === '') {
    return null;
  }

  if (operator === 'equals') {
    return wert.toLowerCase() === vergleich.toLowerCase();
  }
  if (operator === 'notEquals') {
    return wert.toLowerCase() !== vergleich.toLowerCase();
  }

  if (
    operator === 'greaterThan' ||
    operator === 'lessThan' ||
    operator === 'greaterOrEqual' ||
    operator === 'lessOrEqual'
  ) {
    // `Number('')` ist 0 — ohne diese Zeile hiesse »kein Wert« plötzlich »0 ist kleiner als 1«,
    // und die Vorschau behauptete einen Zweig, den die Laufzeit offen lässt.
    if (wert === '') {
      return null;
    }
    const links = Number(wert.replace(',', '.'));
    const rechts = Number(vergleich.replace(',', '.'));
    if (!Number.isFinite(links) || !Number.isFinite(rechts)) {
      return null;
    }
    // Alle vier Größenvergleiche wie die Laufzeit (`runtime.compareValues`); ohne »höchstens« und
    // »mindestens« blieb im Erbschein-Klon jeder zweite Zweig ohne Urteil (Teil 43).
    if (operator === 'greaterThan') return links > rechts;
    if (operator === 'lessThan') return links < rechts;
    if (operator === 'greaterOrEqual') return links >= rechts;
    return links <= rechts;
  }

  return null;
};
